export default "__VITE_ASSET__f96112a3__"